var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDetails = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "info")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Admin/Other",
    transform: "translate(-1231.000000, -9.000000)",
    fill: "#335498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rec/Summary-View-Table"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Summary-View-Table"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info",
    transform: "translate(1231.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5,0 C3.81323077,0 0,3.81296923 0,8.5 C0,13.1870308 3.81323077,17 8.5,17 C13.1867692,17 17,13.1870308 17,8.5 C17,3.81296923 13.1867692,0 8.5,0 Z M8.5,16 C4.36447368,16 1,12.6355263 1,8.5 C1,4.36447368 4.36447368,1 8.5,1 C12.6355263,1 16,4.36447368 16,8.5 C16,12.6355263 12.6355263,16 8.5,16 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.5,
    cy: 5.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,7 C8.224,7 8,7.21333333 8,7.47619048 L8,11.5238095 C8,11.7866667 8.224,12 8.5,12 C8.776,12 9,11.7866667 9,11.5238095 L9,7.47619048 C9,7.21309524 8.776,7 8.5,7 Z",
    id: "Path"
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDetails, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Details.de15ae9e.svg";
export { ForwardRef as ReactComponent };